import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconPlayFrame24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconPlayFrame24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M19 4.5H5A1.5 1.5 0 0 0 3.5 6v1h17V6A1.5 1.5 0 0 0 19 4.5M3.5 18V8.5h17V18a1.5 1.5 0 0 1-1.5 1.5H5A1.5 1.5 0 0 1 3.5 18M5 3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zm5.75 8.787a.25.25 0 0 1 .38-.213l3.557 2.184a.25.25 0 0 1-.004.428l-3.557 2.085a.25.25 0 0 1-.376-.216zm1.166-1.491c-1.166-.716-2.666.123-2.666 1.491v4.268c0 1.352 1.468 2.193 2.635 1.51l3.556-2.084a1.75 1.75 0 0 0 .03-3.002z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconPlayFrame24);
